import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';

import TextInput from 'components/Common/TextInput';
import Button from 'components/Common/CustomButton';
import AuthLayaout from 'pages/Auth/AuthLayout';

import './Auth.css';

const formSchema = yup
    .object({
        tempPassword: yup.string().required('Enter your temporary password'),
    })
    .required();

export interface VerifyTempPasswordFormInputs {
    tempPassword: string;
}

export default function VerifyTempPassword() {
    const navigation = useNavigate();

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<VerifyTempPasswordFormInputs>({
        resolver: yupResolver(formSchema),
        defaultValues: {
            tempPassword: '',
        },
    });

    const submit = () => {
        navigation('../auth/change-password');
    };
    return (
        <AuthLayaout>
            <div className="Auth-form">
                <Stack height={'100%'} direction={'column'} justifyContent={'space-around'}>
                    <Stack direction={'column'}>
                        <p className="Auth-form-title">Temporary Password</p>
                        <p className="Auth-form-text">Enter the temporary password you received in your email below.</p>
                    </Stack>
                    <Controller
                        name="tempPassword"
                        control={control}
                        render={({ field }) => (
                            <TextInput
                                {...field}
                                sx={{ mt: 2, mb: 2 }}
                                icon={null}
                                label="Temporary Password"
                                error={!!errors?.tempPassword}
                                helperText={(errors.tempPassword as any)?.message}
                            />
                        )}
                    />

                    <Button title="SUBMIT" onClick={handleSubmit(submit)} />
                </Stack>
            </div>
        </AuthLayaout>
    );
}
